import { render, staticRenderFns } from "./CommHours.vue?vue&type=template&id=d48847ce&"
import script from "./CommHours.vue?vue&type=script&lang=ts&"
export * from "./CommHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports